var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"f-transaction-status",class:_vm.cStatus},[(_vm.useIcons)?[_c('icon',{attrs:{"data":_vm.getStatusIcon(_vm.status),"width":"20","height":"20","title":_vm.cStatus}})]:[_vm._v(" "+_vm._s(_vm.$t(_vm.cStatus))+" ")]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }